// src/components/Instances/views/Licensed/request/request.ts
import { AxiosInstance, AxiosResponse } from 'axios'

export function fetchUnlicensedInstances(api: AxiosInstance, tenantId: number): Promise<AxiosResponse> {
    return api.get(`/ctxr/-1/listUnlicensed?tenantId=${tenantId}`)
}

export function deleteLicensedInstance(api: AxiosInstance, instanceId: string, tenantId: number): Promise<AxiosResponse> {
    return api.delete(`/ctxr/-1/${instanceId}?tenantId=${tenantId}`)
}
